import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'investors-playbook',
    title: 'Investor’s Playbook',
    description: 'Real-Time Data and Personalized Investment Insights at Your Fingertips',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
        url: 'https://investorsplaybook.com',
    },
};

export default data;
